/* eslint-disable max-len */
// @flow
import React, { PureComponent } from 'react';

// commenter tout ce qui concerne la home custom car non actif

import { STATUS_FAILURE, STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';

import Alert from 'containers/billboard/AlertContainer';
import NextGamesSwiper from 'containers/billboard/NextGameSwiperContainer';
import LiveScore from 'containers/fragments/LiveScoreContainer';
import SocialHub from 'containers/social/SocialHubContainer';
import BillboardCoreByDefault from 'containers/billboard/BillboardCoreByDefaultContainer';
import NewsHub from 'containers/hub/NewsContainer';
// import CompetitionCard from 'components/fragments/card/CompetitionCard';
import Loading from 'components/fragments/Loading';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

import { getPublicAssets } from 'utils/assetsUtils';
import { dynamicClassName } from 'utils/dynamicClassName';

import { withHelmet } from 'infrastructure/seo/Helmet';

import type { HomeType } from 'types/Home';
import type { Status } from 'types/Status';
import type { NextMatchType } from 'types/Settings';
import type { RencontreLiveType } from 'types/Rencontre';
import type { RencontreArticleType } from 'types/Rencontre';

export type StateProps = {
  status: Status,
  banniere: string,
  title: string,
  description: string,
  meta_title_home: string,
  meta_description_home: string,
  clubName: string,
  prochaine_rencontre: ?NextMatchType,
  prochaine_rencontre_lien: string,
  prochainesRencontres: ?(NextMatchType[]),
  placeholder: string,
  google_verification: string,
  rencontresLive: {
    [key: string]: RencontreLiveType
  },
  rencontreArticle: RencontreArticleType,
  home: HomeType,
  homeStatus: Status
};

export type DispatchProps = {
  fetchArticlesStaticCategories(): void,
  fetchHome(): void,
  fetchRencontreArticle(id: string): void
};

type Props = StateProps & DispatchProps;

class Billboard extends PureComponent<Props> {
  componentDidMount() {
    const { fetchRencontreArticle, fetchArticlesStaticCategories, fetchHome } = this.props;
    fetchHome();
    fetchArticlesStaticCategories();
    this.props.prochaine_rencontre && this.props.prochaine_rencontre.id && fetchRencontreArticle(this.props.prochaine_rencontre.id);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.prochaine_rencontre && this.props.prochaine_rencontre.id) {
      const { prochaine_rencontre } = this.props;
      if (
        prochaine_rencontre.id &&
        (!prevProps.prochaine_rencontre ||
          !prevProps.prochaine_rencontre.id ||
          prevProps.prochaine_rencontre.id !== prochaine_rencontre.id ||
          (Object.keys(prevProps.rencontresLive).includes(prochaine_rencontre.id) &&
            !Object.keys(this.props.rencontresLive).includes(prochaine_rencontre.id)) ||
          (!Object.keys(prevProps.rencontresLive).includes(prochaine_rencontre.id) &&
            Object.keys(this.props.rencontresLive).includes(prochaine_rencontre.id)))
      ) {
        const { fetchRencontreArticle } = this.props;
        this.props.prochaine_rencontre && this.props.prochaine_rencontre.id && fetchRencontreArticle(prochaine_rencontre.id);
      }
    }
  }

  render() {
    const {
      status,
      title,
      description,
      prochaine_rencontre,
      // prochaine_rencontre_lien,
      prochainesRencontres,
      banniere,
      rencontresLive,
      // rencontreArticle,
      home,
      homeStatus
    } = this.props;

    const placeholderBanner = getPublicAssets('/img/trash/home-ffr/Slider@2x.jpg');

    const sliderClass = dynamicClassName('home-slider');
    prochaine_rencontre && sliderClass.add('has-score');

    return (
      <>
        <Alert />
        <section className={sliderClass.build()}>
          {status !== STATUS_SUCCESS ? (
            <Loading />
          ) : (
            <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${banniere || placeholderBanner})` }} />
          )}

          <div className="container">
            <div className="home-slider__wrapper">
              <div className="home-slider__item">
                <h2>{title}</h2>
                <p className="banner__desc">{description}</p>
              </div>
            </div>
          </div>

          <LiveScore />
        </section>
        {/* <section className="container">
          {prochaine_rencontre && rencontreArticle && rencontreArticle.id === prochaine_rencontre.id && (
            <>
              <CompetitionCard lives={rencontresLive} match={rencontreArticle} link={prochaine_rencontre_lien} upcomingMatch isBig isDark />
            </>
          )}
        </section> */}

        {prochainesRencontres && prochainesRencontres.length > 0 && (
          <section className="container">
            <NextGamesSwiper nextGames={prochainesRencontres} rencontresLive={rencontresLive} />
          </section>
        )}

        {homeStatus === STATUS_LOADING && (
          <section className="container section">
            <Loading />
          </section>
        )}

        {(homeStatus === STATUS_FAILURE || (homeStatus === STATUS_SUCCESS && !home.content.length)) && <BillboardCoreByDefault />}

        {homeStatus === STATUS_SUCCESS && !!home.content.length && (
          <>
            <section className="container section" style={{ paddingBottom: '0px' }}>
              <NewsHub rowClassNames="row" />
            </section>

            <section className="section content-bloc">
              {home.content.map((bloc, index) => (
                <ContentBloc key={index} {...bloc} />
              ))}
            </section>
          </>
        )}

        <SocialHub />
      </>
    );
  }
}

export default withHelmet(Billboard)((Helmet, pageProps) => {
  const { title, meta_title_home, meta_description_home, clubName, placeholder, google_verification } = pageProps;
  return (
    <Helmet>
      <title>{meta_title_home ?? clubName ? `Site officiel du club de rugby ${clubName}` : 'Site officiel du club de rugby - FFR'}</title>
      <meta name={'description'} content={meta_description_home} />
      <meta name={'keywords'} content={title} />
      <meta
        property={'og:title'}
        content={meta_title_home ?? clubName ? `Site officiel du club de rugby ${clubName}` : 'Site officiel du club de rugby - FFR'}
      />
      <meta property={'og:description'} content={meta_description_home} />
      <meta property={'og:image'} content={placeholder} />
      <meta property={'og:image:url'} content={placeholder} />
      {google_verification && <meta name="google-site-verification" content={google_verification} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
